const o="v1";export{o as API_VERSION};
